import React from 'react';
import ViewVideoPackagePaymentSettingComponent from '../../../Components/VideoPackagePaymentSetting/ViewVideoPackagePaymentSetting';

export default function ViewVideoPackagePaymentSetting() {
    return (
        <div className='page-body'>
            <ViewVideoPackagePaymentSettingComponent />
        </div>
    );
}